import React from 'react';
import { AllPatientsTableContainer } from '../AllPatientsTable/AllPatientsTableContainer';

export const PatientsContainer = () => {
    return <AllPatientsTableContainer />;
};
